module.exports = __webpack_public_path__ + "static/scenario1-cf8334b289374625acfa6ae2b8039b48.png";